/* eslint-disable no-unused-vars */
/* global G, React */
import { Grid } from '@mui/material'
import { findKey } from 'lib/util/array'
import ApplicationContext from 'platform/react/context/application'
import { useContext } from 'react'
import Text from 'ui/Element/Text'

/**
 * Fallback NoData component
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
const NoData = (props) => {
  const { intl } = useContext(ApplicationContext)

  return (
    <Grid
      item
      container
      key={'nodata'}
      justifyContent={'center'}
      xs={props.xs}
      sm={props.sm}
      md={props.md}
      lg={props.lg}
      xl={props.xl}
    >
      <Text
        align={'center'}
        color={'black.main'}
        variant={'16/medium'}
      >
        {
          intl._t('label.noData', {
            ns: 'common',
            _key: 'label.noData',
            defaultValue: 'No data',
          })
        }
      </Text>
    </Grid>
  )
}

/**
 * NoData HOC component.
 *
 * Will return `ui/Element/Placeholder/NoData` if defined in config,
 * otherwise it will return {@link NoData}.
 *
 * @param {React.ReactNode} Component child component
 * @returns {function(*, *): *}
 */
const NoDataHOC = Component => (props, ref) => {
  const { fromSearch = false, unsegmented = false } = props

  const children = [...props.children || []]
  const index = children.findIndex(child => child.key === 'nodata')
  const [noDataPlaceholder = <NoData {...props} />] = index > -1 ? children.splice(index, 1) : []
  const childProps = { ...props, forwardedRef: ref, children }

  return (
    <Component
      {...childProps}
      fromSearch={fromSearch}
      noData={noDataPlaceholder}
      unsegmented={fromSearch || unsegmented}
    />
  )
}

export default Component => React.forwardRef(NoDataHOC(Component))
